import { validStateCodesCA as t, validStateCodesUS as A } from "@cx-modules/constants";
import { isLoggedIn as l } from "./myoc.js";
const r = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  FM: "Federated States of Micronesia",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  PW: "Palau",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "U.S. Virgin Islands",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
  MP: "Northern Mariana Islands",
  MH: "Marshall Islands"
}, S = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon"
}, e = (a, s) => a.reduce(
  (o, i) => (o[i] = { code: i, name: s[i] }, o),
  {}
), I = {
  US: {
    code: "US",
    name: "United States",
    subdivisions: e(A, r)
  },
  CA: {
    code: "CA",
    name: "Canada",
    subdivisions: e(t, S)
  }
}, E = {
  LINK: "LINK",
  ALL_SPORTS_EXPANDABLE: "ALL_SPORTS_EXPANDABLE",
  FEATURED_LINKS: "FEATURED_LINKS",
  LINK_GROUP: "LINK_GROUP",
  GROUP: "GROUP",
  SPLIT_EXPANDABLE: "SPLIT_EXPANDABLE",
  FLAT_ITEMS_EXPANDABLE: "FLAT_ITEMS_EXPANDABLE",
  MY_ACCOUNT: "MY_ACCOUNT",
  ODDS_FORMAT: "ODDS_FORMAT",
  BETSLIP: "BETSLIP",
  STATE_SELECTOR: "STATE_SELECTOR"
}, O = {
  PROMO_CODE: "PROMO_CODE"
}, C = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary"
}, M = {
  DISCLAIMER: "DISCLAIMER",
  LOGO: "LOGO"
}, n = {
  AMERICAN: "american",
  DECIMAL: "decimal",
  FRACTIONAL: "fractional",
  TRADITIONAL: "traditional"
}, T = (a) => ({
  American: a === n.AMERICAN,
  Decimal: a === n.DECIMAL,
  Fractional: a === n.FRACTIONAL
}), L = ["WS", "US", "OC", "GZ"], c = {
  GZ: "it",
  OC: "uk",
  US: "us",
  WS: "uk"
}, d = {
  OC: "uk",
  US: "us",
  WS: "uk",
  GZ: "it"
};
export {
  S as CA_SUBDIVISION_NAMES,
  n as ODDS_FORMAT,
  c as REPUB_COUNTRY,
  d as REPUB_COUNTRY_BY_REPUB,
  L as SUPPORTED_REPUB_NAMES,
  r as US_SUBDIVISION_NAMES,
  I as countriesByCodeWithSubdivisions,
  M as footerItemType,
  T as getOddsFormatIs,
  l as isLoggedIn,
  E as navItemType,
  O as navItemsType,
  C as variant
};
